import { BaseAPIService } from './base';
import { getNotionToken } from '../../config';
import { supabase } from './client';

class TermsService extends BaseAPIService {
  constructor() {
    super('terms'); // Table name is 'terms'
  }

  // 용어 목록 가져오기
  async getTerms() {
    try {
      const { data, error } = await supabase
        .from('terms')
        .select('*')
        .order('term', { ascending: true });

      if (error) {
        console.error('❌ Supabase 용어 조회 오류:', error);
        throw new Error(`Supabase 오류: ${error.message}`);
      }

      return data || [];
    } catch (error) {
      console.error('❌ 용어 데이터 로딩 실패:', error);
      throw error;
    }
  }

  // 새 용어 추가
  async addTerm(termData) {
    try {
      const { data, error } = await supabase
        .from('terms')
        .insert([termData])
        .select();

      if (error) {
        console.error('❌ Supabase 용어 추가 오류:', error);
        throw new Error(`Supabase 오류: ${error.message}`);
      }

      return data[0];
    } catch (error) {
      console.error('❌ 용어 추가 실패:', error);
      throw error;
    }
  }

  // 용어 수정 (Notion API 유지)
  async updateTerm(termId, termData) {
    try {
      const notionToken = getNotionToken();

      const response = await fetch(`https://api.notion.com/v1/pages/${termId}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${notionToken}`,
          'Notion-Version': '2022-06-28',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          properties: {
            Term: {
              title: [
                {
                  text: {
                    content: termData.term
                  }
                }
              ]
            },
            Definition: {
              rich_text: [
                {
                  text: {
                    content: termData.definition
                  }
                }
              ]
            },
            Subject: {
              select: {
                name: termData.subject
              }
            },
            Hint: termData.hint ? {
              rich_text: [
                {
                  text: {
                    content: termData.hint
                  }
                }
              ]
            } : null,
            Keywords: {
              multi_select: termData.keywords.map(keyword => ({
                name: keyword
              }))
            }
          }
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API 요청 실패: ${response.status} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('❌ 용어 수정 실패:', error);
      throw error;
    }
  }

  // 용어 삭제
  async deleteTerm(termId) {
    try {
      const { error } = await supabase
        .from('terms')
        .delete()
        .eq('id', termId);

      if (error) {
        console.error('❌ Supabase 용어 삭제 오류:', error);
        throw new Error(`Supabase 오류: ${error.message}`);
      }

      return { success: true };
    } catch (error) {
      console.error('❌ 용어 삭제 실패:', error);
      throw error;
    }
  }
}

export const termsService = new TermsService();

// Backward compatibility exports
export const fetchTerms = () => termsService.getTerms();
export const addTerm = (termData) => termsService.addTerm(termData);
export const updateTerm = (termId, termData) => termsService.updateTerm(termId, termData);
export const deleteTerm = (termId) => termsService.deleteTerm(termId); 